import React, { useEffect } from 'react'
import { useTheme } from '@/hooks/use-theme'

type Props = { children: React.ReactNode }

// Lightweight provider to initialize and react to theme changes.
// useTheme handles DOM side-effects and persistence via the UI store.
export function ThemeProvider({ children }: Props) {
  const { setTheme } = useTheme()

  useEffect(() => {
    if (import.meta.env.MODE === 'test') {
      setTheme('system')
    }
  }, [setTheme])

  return <>{children}</>
}

export default ThemeProvider
